module.exports = __webpack_public_path__ + "static/jung-thumb-642641df1ef6345749b4d06af81778bd.png";